module.exports = __webpack_public_path__ + "static/media/2.6_preview.3f53afb8.png";